import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import { ColumnChart } from '../../Reports/templates/BarAndColumnCharts';
import MetricCard from '../MetricCard';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getMentorMenteeAvailabilityChartConfig from './utils';
import { exportEventName } from '.';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';
import i18n from '../../../../utils/ChrI18n';
import ChrLink from '../../../generic/Utils/ChrLink';

const Body = (props) => {
  const { metrics } = props;
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();

  const availableMentors = getMetricDataFromArray(metrics, MetricUId.AVAILABLE_MENTORS);
  const availableMentorsCapacity = getMetricDataFromArray(metrics, MetricUId.AVAILABLE_MENTORS_CAPACITY);
  const chartData = [getMetricDataFromArray(metrics, MetricUId.CURRENTLY_UNCONNECTED_MENTEES), availableMentorsCapacity]

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="max-height-500" >
      <div className='d-flex flex-column' ref={ chartWrapperReference }>
        <MetricCard
          value={ availableMentors.data.value }
          url={ availableMentors.url }
          title={ availableMentors.name }
          className="mb-4"
          helpText={ availableMentors.shortHelpText }
          eventDetails={ availableMentors.eventDetails }
        />
        <div className="align-self-stretch">
          <ColumnChart
            chartOptions={ getMentorMenteeAvailabilityChartConfig(chartData, { exportFileName: props.name }) }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
        { availableMentorsCapacity.defaultConnectionCapacity &&
          <div className='cui-widget-info-bg d-flex flex-gap-10 p-3 border-radius-0-25 font-bold '>
            <i className="fa-regular fa-gear mt-1" />
            <span>{ availableMentorsCapacity.defaultConnectionCapacity.infoText }</span>
            <ChrLink newTab href={ availableMentorsCapacity.defaultConnectionCapacity.url }>({ i18n.t("display_string.Change") })</ChrLink>
          </div>
        }
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;
